import React, { useEffect } from 'react';

import PerfectScrollBar from 'react-perfect-scrollbar';
import {
  numberFormat,
  formatDateVietStock,
  showPosition,
} from '../../../../utils';
import { translate } from 'react-i18next';

const TransferData = ({ symbol, transferData, t, loadTransferData }) => {
  useEffect(() => {
    loadTransferData();
  }, [symbol]);

  return (
    <div className="tab-history">
      <PerfectScrollBar
        style={{ height: 'calc( 100vh - 315px )' }}
        className="mt-2"
      >
        <table className="table table-borderless" style={{minWidth: '900px'}}>
          <thead>
            <tr>
              <th rowSpan="2">STT</th>
              {/* <th rowSpan="2">Mã CK</th> */}
              <th rowSpan="2">Loại GD</th>
              <th colSpan="2">Người thực hiện</th>
              <th colSpan="3">Người liên quan tại tổ chức NY</th>
              <th colSpan="3">Thực hiện</th>
              <th colSpan="2">Sau GD</th>
            </tr>
            <tr>
              <th>Họ và tên</th>
              <th>Chức vụ</th>
              <th>Họ và tên</th>
              <th>Chức vụ</th>
              <th>Quan hệ</th>
              <th>KLGD</th>
              <th className="mw-75">Từ ngày</th>
              <th className="mw-75">Đến ngày</th>
              <th>KL</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {transferData &&
              !!transferData.length &&
              transferData.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  {/* <td className="text-center">{item.StockCode}</td> */}
                  <td className="text-left">{item.TypeName}</td>
                  <td className="text-left">{item.DTTHCD || item.DTTHLQ}</td>
                  <td className="text-left">{showPosition(item.PositionCD)}</td>
                  <td className="text-left text-nowrap">{item.DTLQLQ}</td>
                  <td className="text-left">{showPosition(item.ExtraPositionNLQ)}</td>
                  <td className="text-left">{showPosition(item.RelationShipType)}</td>
                  <td className={"text-right " + (item.SellVolume ? 'bg-sell' : item.BuyVolume ? 'bg-buy' : '')}>
                    {item.SellVolume && numberFormat(item.SellVolume, 0)}
                    {item.BuyVolume && numberFormat(item.BuyVolume, 0)}
                  </td>
                  <td className="text-center">
                    {formatDateVietStock(item.DateActionFrom)}
                  </td>
                  <td className="text-center">
                    {formatDateVietStock(item.DateActionTo)}
                  </td>
                  <td className="text-right">
                    {numberFormat(item.RegisterVolumeAfter, 0)}
                  </td>
                  <td className="text-right">
                    {numberFormat(item.VolumeAfterPercent, 2, '-')}%
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {(!transferData || !transferData.length) && (
          <p className="text-center title-read fz-14">Không có dữ liệu</p>
        )}
      </PerfectScrollBar>
    </div>
  );
};

export default translate('translations')(TransferData);
